import { useEffect } from 'react';
import Spinner from 'components/molecules/Spinner/Spinner';
import axios from 'axios';
import { api } from 'api/api';
import { useHistory } from 'react-router-dom';

const OAuthCallback = ({ queryParams, setToken, setQueryParams }) => {
  const history = useHistory();

  useEffect(() => {
    axios
      .post(`${api}oidc/token/`, {
        state: queryParams.state,
        code: queryParams.code,
        session_state: queryParams.sessionState,
      })
      .then((response) => {
        if (response.status === 200) {
          setToken(response.data.data);
          history.replace('/items-list');
        }
      })
      .finally(() => {
        setQueryParams({});
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Spinner className="oauth-spinner" />
    </>
  );
};

export default OAuthCallback;
